// Побудова Markdown-документів тікету: головний файл та переписка чату.

import { nameWorker } from "@/usabilityScripts/getNameWorker";
import { htmlToMarkdown } from "./htmlToMarkdown";

// Будує головний Markdown-документ тікету.
// Наповнює переданий масив images зображеннями з опису тікету.
// opts: { images, hasChat, chatFilename, attachments (підготовлені, з archivedName/isLog) }
function buildMainMarkdown(ticket, opts){
    let { images, hasChat, chatFilename, attachments } = opts;
    let lines = [];

    lines.push(`# Тікет #${ticket.ticketId} — ${ticket.ticketName || ""}`); // заголовок - номер та назва тікету
    lines.push("");
    lines.push("## Опис тікету");
    lines.push("");

    // опис тікету зберігається в полі createComment (з HTML-розміткою та зображеннями)
    let description = htmlToMarkdown(ticket.createComment || ticket.reason || "", images);
    lines.push(description || "-");
    lines.push("");

    // вказуємо, що переписка чату винесена в окремий файл
    if(hasChat){
        lines.push("## Чат");
        lines.push("");
        lines.push(`Переписка чату в окремому файлі: [${chatFilename}](${chatFilename})`);
        lines.push("");
    }

    // згадка про вкладення (логи та інші матеріали)
    if(attachments.length > 0){
        lines.push("## Файли");
        lines.push("");
        for(let file of attachments){
            let dt = file.datetime ? ` (${file.datetime})` : "";
            let note = file.isLog ? " — логи (zip-архів)" : "";
            lines.push(`- [${file.archivedName}](files/${file.archivedName})${dt}${note}`);
        }
        lines.push("");
    }

    return lines.join("\n");
}

// Будує Markdown-переписку чату тікету.
// messages - масив повідомлень з API (workerId, datetime, message (HTML), deleted).
// Наповнює переданий масив images зображеннями з повідомлень (спільна папка images).
function buildChatMarkdown(ticket, messages, images){
    let lines = [];
    lines.push(`# Чат тікета #${ticket.ticketId} — ${ticket.ticketName || ""}`);
    lines.push("");

    // API віддає повідомлення від новіших до старіших - розгортаємо в хронологічний порядок
    let ordered = Array.isArray(messages) ? [...messages].reverse() : [];

    for(let msg of ordered){
        if(msg.deleted){
            continue; // видалені повідомлення не експортуємо
        }

        let author = nameWorker(msg.workerId) || "-";
        let datetime = msg.datetime || "";
        lines.push(`**${author}**${datetime ? ` · ${datetime}` : ""}`);
        lines.push("");

        let text = htmlToMarkdown(msg.message || "", images);
        lines.push(text || "-");
        lines.push("");
        lines.push("---");
        lines.push("");
    }

    return lines.join("\n").trim() + "\n";
}

export { buildMainMarkdown, buildChatMarkdown };
